import { HistoryIcon, CreditCardIcon, PromoIcon, QuestionIcon } from "@boundary/components/icons";
import { PointsIcon } from "@boundary/components/bonusIcons/bonusIcons";
import { PrefetchLink } from "@boundary/components/prefetchLink";
import styles from "./actions.module.scss";

interface MenuActionCardProps {
  route: string;
  children: string;
  icon: React.ReactNode;
}

function MenuActionCard({ route, children, icon }: MenuActionCardProps) {
  return (
    <div className={styles.card}>
      <span className={styles.cardTitle}>{children}</span>
      <div className={styles.cardIcon}>{icon}</div>
      <PrefetchLink to={route} className={styles.cardLink} />
      </div>
  );
}

const MENU_ACTIONS = [
  { route: "/order/history", icon: <HistoryIcon size={14} />, label: "История заказов" },
  { route: "/payment/settings", icon: <CreditCardIcon size={14} />, label: "Способ оплаты" },
  { route: "/bonuses", icon: <PointsIcon className={styles.pointsIcon} />, label: "Мои бонусы" },
  { route: "/discounts", icon: <PromoIcon size={14} />, label: "Промокоды и скидки" },
  { route: "/referral", icon: <PromoIcon size={14} />, label: "Реферальная программа" },
  { route: "/support", icon: <QuestionIcon size={11} />, label: "Помощь" },
] as const;

export function MenuActions() {
  return (
    <div className={styles.menu}>
      <h2 className={styles.title}>Действия</h2>
      <div className={styles.grid}>
        {MENU_ACTIONS.map((action) => (
          <MenuActionCard
            key={action.route}
            route={action.route}
            icon={action.icon}
          >
            {action.label}
          </MenuActionCard>
        ))}
      </div>
    </div>
  );
}
